export const extensionRoutes = [  {
    path: 'extensions/dealers',
    loadChildren: () => import('./extensions/dealers-ui/routes'),
  }];
